// import { IState, IWidgetDetails } from "@/lib/widgetsLayoutDir";
import { returnMinSizeForComponent } from "@/lib/reactGridLayout/widgetMinSizeHelper";
import { IState, IWidgetDetails } from "@/lib/widgetsLayoutDir";
import { Layout } from "react-grid-layout";

// LQC-2517: mins come from baseWidgetDetails so the default workspace can never drift
// from the widget menu. Non-null - every component below has a directory entry.
const actionSummaryMin = returnMinSizeForComponent("ActionSummary")!;
const tradeCreationMin = returnMinSizeForComponent("TradeCreation")!;
const tradeTileMin = returnMinSizeForComponent("TradeTile")!;

export function clearWokspaceLayout(prevState: any) {
  return {
    ...prevState,
    layouts: {
      lg: [],
      sm: [],
    },
    openWidgets: [],
  };
}

export function cubeDefaultWorkspaceTab(prevState: IState) {
  // Generate 5 different UUID's so they can be applied to match on the two arrays.
  const widgetID1 = crypto.randomUUID();
  const widgetID2 = crypto.randomUUID();
  const widgetID3 = crypto.randomUUID();
  // let widgetID5 = crypto.randomUUID();

  const openWidgetsLargeArr: IWidgetDetails[] = [
    {
      i: `Action Summary-${widgetID1}`,
      component: "ActionSummary",
      icon: "AS",
      displayName: "Action Summary",
      x: 0,
      y: 0,
      w: 12,
      h: 10,
      ...actionSummaryMin,
    },
    {
      i: `Trade Creation-${widgetID2}`,
      component: "TradeCreation",
      icon: "TC",
      displayName: "Trade Creation",
      x: 7,
      y: 2,
      w: 6,
      h: 8,
      ...tradeCreationMin,
    },
    {
      i: `Trade Tile-${widgetID3}`,
      component: "TradeTile",
      icon: "TT",
      displayName: "Trade Tile",
      x: 0,
      y: 2,
      w: 6,
      h: 8,
      ...tradeTileMin,
    },
    // {
    //   i: `Trade Tile-${widgetID4}`,
    //   component: "TradeTile",
    //   icon: "TT",
    //   displayName: "Trade Tile",
    //   x: 9,
    //   y: 2,
    //   w: 3,
    //   h: 8,
    //   minW: 4,
    // },
  ];

  //----------List of widgets/components that make up default layout----------
  const defaultLargeArr: Layout[] = [
    {
      i: `Action Summary-${widgetID1}`,
      x: 0,
      y: 0,
      w: 12,
      h: 10,
      ...actionSummaryMin,
    },
    {
      i: `Trade Creation-${widgetID2}`,
      x: 7,
      y: 2,
      w: 6,
      h: 8,
      ...tradeCreationMin,
    },
    {
      i: `Trade Tile-${widgetID3}`,
      x: 0,
      y: 2,
      w: 6,
      h: 8,
      ...tradeTileMin,
    },
    // {
    //   i: `Trade Tile-${widgetID4}`,
    //   x: 7,
    //   y: 2,
    //   w: 6,
    //   h: 8,
    // },
  ];

  return {
    ...prevState,
    layouts: {
      lg: defaultLargeArr,
      sm: defaultLargeArr,
    },
    openWidgets: openWidgetsLargeArr,
  };
}
